import { useSetAtom, useAtomValue } from "jotai";
import {
  creditUploadDocumentsAtom,
  isCreditAttachingAtom,
  isCreditDocumentUploadOpenAtom,
  creditUploadSelectedModalIdAtom,
  openCreditDocumentUploadAtom,
  closeCreditDocumentUploadAtom,
  uploadCreditDocumentAtom,
  addCreditDocumentUploadAtom,
  clearCreditDocumentUploadAtom,
  removeCreditDocumentAtom,
  setCreditIsAttachingAtom,
  updateCreditAfterUploadAtom,
} from "../atom/documentUpload";

function useCreditDocumentUpload() {
  const isDocumentUploadOpen = useAtomValue(isCreditDocumentUploadOpenAtom);
  const documents = useAtomValue(creditUploadDocumentsAtom);
  const isAttaching = useAtomValue(isCreditAttachingAtom);
  const selectedModalId = useAtomValue(creditUploadSelectedModalIdAtom);

  const openDocumentUpload = useSetAtom(openCreditDocumentUploadAtom);
  const closeDocumentUpload = useSetAtom(closeCreditDocumentUploadAtom);
  const addDocumentUpload = useSetAtom(addCreditDocumentUploadAtom);
  const clearDocumentUpload = useSetAtom(clearCreditDocumentUploadAtom);
  const uploadDocument = useSetAtom(uploadCreditDocumentAtom);
  const removeDocument = useSetAtom(removeCreditDocumentAtom);
  const setIsAttaching = useSetAtom(setCreditIsAttachingAtom);
  const updateCredit = useSetAtom(updateCreditAfterUploadAtom);

  return {
    isDocumentUploadOpen,
    selectedModalId,
    documents,
    isAttaching,
    openDocumentUpload,
    closeDocumentUpload,
    addDocumentUpload,
    uploadDocument,
    clearDocumentUpload,
    removeDocument,
    setIsAttaching,
    updateCredit,
  };
}

export { useCreditDocumentUpload };
